import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useSizeIdFromStateOrParams} from '../../../features/ProductUrl/useSizeIdFromStateOrParams';
import {getSizeByIdOrLabel} from '../../../features/SizeSelection/getSizeByIdOrLabel';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {useSizesSection as useSizesSectionMinimal} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {useSizesSection} from '../useGetProductBulkSection';

export const useGetVidParamOrManualPreselectedSize = ({
  selectedSize,
  isInMiniADPDialog,
  productId = 0,
}: {
  selectedSize: SelectedSize;
  isInMiniADPDialog: boolean;
  productId?: number;
}) => {
  const paramsPreselectedSizeId = useSizeIdFromStateOrParams();
  const sizesSection = useSizesSection({disabled: isInMiniADPDialog});
  const sizesSectionMinimal = useSizesSectionMinimal(
    productId,
    undefined,
    !isInMiniADPDialog,
  );
  const sizesSectionData = isInMiniADPDialog
    ? sizesSectionMinimal.data
    : sizesSection.data;

  let size: SizeSelection_Size | undefined = selectedSize;
  if (sizesSectionData && !selectedSize && paramsPreselectedSizeId) {
    size = getSizeByIdOrLabel({
      sizeSelection: sizesSectionData.sizeSelection,
      sizeIdentifier: {type: 'id', id: String(paramsPreselectedSizeId)},
    });
  }

  return size;
};
